<template><div id="app" @mousemove="mousemove" @mousedown="mousedown">
  <div class="hoverInfo" :style="hoverStyle" v-if="hoverUnit || hoverPoi">
    <template v-if="hoverUnit">
      <table>
      <tr><th>Name</th><td> {{ hoverUnit.name }}</td></tr>
      <tr v-if="lastReport"><th>Last Report</th><td>{{ lastReport }}</td></tr>
      <tr><th>Status</th><td><span :style="{color:hoverStatus.color}">&#x2B24;</span> {{ hoverStatus.text }}</td></tr>
      <tr v-for="row in (hoverData[hoverUnitId] || [])" :key="`hoverDataRow-${row[0]}`">
        <th v-html="row[0]" />
        <td v-html="row[1] !== null ? row[1] : '-'" />
      </tr>
      </table>
      <template v-if="hoverUnit && !hoverData[hoverUnitId]">
        <em v-if="hoverRef">Loading...</em>
        <em v-else>Failed to load additional info.</em>
      </template>
    </template>
    <span v-else-if="hoverPoi" v-html="hoverPoi.name" />
  </div>
  <modal-dialog v-if="$store.state.showInvitations" :strong="true" @close="$store.commit('hideInvitations')">
    You have received a fleet invitation.
    <button @click="reviewInvitation">Review</button>
  </modal-dialog>
  <div class="content">
    <transition :name="viewTransition" appear>
        <router-view />
    </transition>
  </div>
  <div class="main-menu"
      :class="{visible:$store.state.menuVisible,'force-modal':!listening}"
      @click.self="hideMenu"
      >
    <div v-if="$store.state.activeMenu === 'main'">
      <h1><img src="../assets/logo72.png" /> TMV Remote</h1>
      <div @click="hideMenu">
        <router-link to="/login" v-if="!user">Login</router-link>
        <template v-else>
          <router-link to="/alerts" v-if="listening" exact class="inbox">
            <span>Inbox</span><span v-if="unreadCount" v-html="unreadCount <= 99 ? unreadCount : '99+'" />
          </router-link>
          <span v-else class="inbox">
            <span>Inbox</span><span v-if="unreadCount" v-html="unreadCount <= 99 ? unreadCount : '99+'" />
          </span>
        </template>
        <template v-if="uids_sorted_by_name.length">
          <router-link to="/" v-if="listening" exact>Diagnostics</router-link>
          <span v-else>Diagnostics</span>
        </template>
        <template v-if="user">
          <router-link to="/s" v-if="listening" exact>Settings</router-link>
          <span v-else>Settings</span>
        </template>
        <template v-if="user && user.is_superuser">
          <router-link to="/a/email" v-if="listening" exact>Admin</router-Link>
          <span v-else>Admin</span>
        </template>
        <template v-if="user && user.is_staff">
          <router-link to="/provisioning" v-if="listening" exact>Provisioning</router-link>
          <span v-else>Provisioning</span>
        </template>
        <template v-if="permissions && permissions.isAccountant">
          <router-link to="/billing" v-if="listening">Billing</router-link>
          <span v-else>Billing</span>
        </template>
        <template v-if="user">
          <router-link v-if="listening" to="/h/about" exact>About</router-link>
          <span v-else>About</span>
        </template>
        <!--
        <router-link to="/preferences" v-if="user">Preferences</router-link>
        <router-link to="/link">Direct Link</router-link>
        <router-link to="/help">Help</router-link>
        -->
        <template v-if="user">
          <form
              v-if="listening"
              id="logoutForm"
              ref="logoutForm"
              action="/user"
              method="POST">
            <input
                type="hidden"
                name="csrfmiddlewaretoken"
                :value="csrftoken"
              />
            <input type="hidden" name="action" value="logout" />
            <a href="." @click.prevent="logout">Logout</a>
          </form>
          <span v-else>Logout</span>

          <a href="." @click.prevent="listen" v-if="!listening" class="status error">
            Connection lost.<br/>
            <hr/>
            Tap here to reconnect...
          </a>
          <a v-else-if="listening === true" class="status okay">Online.</a>
          <a v-else class="status warn">Connecting...</a>
        </template>
      </div>
    </div>
  </div>
</div></template>

<script>
import Cookies from 'js-cookie'
import { mapState, mapGetters, mapActions } from 'vuex'
import ModalDialog from './ModalDialog'
import moment from 'moment'
import api from '../api'
export default {
  name: 'app',
  components: { ModalDialog },
  created() {
    this.checkUser()
    this.listen()
  },
  data() {
    return {
      viewTransition: 'replace',
      hoverData: {},
      hoverRef: null,
    }
  },
  computed: {
    ...mapState([
      'user',
      'permissions',
      'fleets',
      'listening',
      'hoverUnitId',
      'hoverPoi',
      'mousePosition',
      'uids_sorted_by_name',
      'unreadCount',
    ]),
    ...mapGetters([
      'unitStatus',
    ]),
    hoverStatus() {
      if (this.hoverUnit)
        return this.unitStatus(this.hoverUnit)
      return null
    },
    hoverStyle() {
      let w = this.$el.clientWidth,
        h = this.$el.clientHeight,
        x = this.mousePosition[0],
        y = this.mousePosition[1],
        m = 10,
        s = {}
      if (x < w / 2) {
        s.left = `${x+m}px`
      } else {
        s.right = `${w-x+m}px`
      }
      if (y < h / 2) {
        s.top = `${y+m}px`
      } else {
        s.bottom = `${h-y+m}px`
      }
      return s
    },
    hoverUnit() {
      return this.$store.state.units[this.hoverUnitId] || null
    },
    lastReport() {
      if (moment().diff(this.hoverUnit.lastPacketTime) > 30*24*60*60*1000)
        return this.hoverUnit.lastPacketTime.format('YYYY-MMM-DD')
      else if (this.hoverUnit.lastPacketTime)
        return this.hoverUnit.lastPacketTime.fromNow()
      else
        return null
    },
    csrftoken: () => Cookies.get('csrftoken'),
  },
  methods: {
    ...mapActions(['listen']),
    hamClick(e) {
      window.scrollTo(0,0)
    },
    scroll() {
      let el = document.getElementsByTagName('h1')[0]
      if (el) el.scrollIntoView()
    },
    logout() {
      this.$refs.logoutForm.submit()
    },
    checkUser() {
      if (!this.user && !this.$route.meta.anonymous) {
        this.$router.push('/login?n=' + encodeURI(this.$route.fullPath))
      }
    },
    mousemove(e) {
      this.$store.commit('mousemove', [e.pageX,e.pageY])
    },
    mousedown(e) {
      this.$store.commit('hoverUnitId', null)
      this.$store.commit('hoverPoi', null)
    },
    async fetchHoverData() {
      if (this.hoverUnit === null)
        return
      let d = this.hoverData[this.hoverUnitId]
      if (d === true) return // already fetching
      if (d) {
        let dt = new Date().getTime() - d.fetchedAt
        if (dt < 2*1000) return // fetched very recently
        if (moment(d.fetchedAt).isAfter(this.hoverUnit.lastPacketTime)) return // no new data available
      }

      // About to initiate new request. Cancel old one.
      if (this.hoverRef)
        this.hoverRef.cancel()

      // Clear the old data.
      delete this.hoverData[this.hoverUnitId]

      let ref = null
      try {
        await new Promise((y,n) => {
          let timeout = setTimeout(y, 200)
          this.hoverRef = ref = {
            cancel() {
              clearTimeout(timeout)
              n()
            },
            hidden: true,
          }
        })
        this.hoverRef = ref = { uid: this.hoverUnitId }
        d = await api.unitAdditionalData(this.hoverRef)
        d.fetchedAt = new Date().getTime()
        this.hoverData[this.hoverUnitId] = d
      } catch(e) { }

      // Clean up the request.
      if (ref === this.hoverRef)
        this.hoverRef = null
    },
    hideMenu() {
      if (this.listening || this.$route.meta.offline)
        this.$store.commit('hideMenu')
    },
    async reviewInvitation() {
      this.$store.commit('hideInvitations')
      try {
        await this.$router.push('/s/me')
      } catch(e) {}
    },
  },
  watch: {
    hoverUnitId() { this.fetchHoverData() },
    user() {
      this.checkUser()
      if (!this.listening) {
        this.listen()
      }
    },
    listening(nv,ov) {
      if (nv === false) {
        this.$store.commit('showMenu')
      }
    },
    $route() {
      this.hideMenu()
    },
  },
}
</script>

<style lang="scss">

@import url('https://fonts.googleapis.com/icon?family=Material+Icons');
@import url('https://fonts.googleapis.com/css?family=Roboto|Lobster&display=swap');

@import '../style/globals.scss';
html, body {
  margin: 0;
  padding: 0;
  font-family: Roboto;
  font-size: 16px;
  user-select: none;
  -webkit-touch-callout: none;
}
.selectable {
  @include user-select(true);
}
input, button, textarea, select {
  font-family: Roboto;
  font-size: 1rem;
  border: 1px solid #000;
  border-radius: 5px;
  padding: 2px 5px;
}
button {
  padding: 5px 10px;
  border-radius: 5px;
  border: none;
  background: #ccc;
  cursor: pointer;
  outline: none;
  &:hover {
    background: #ddd;
  }
}
select {
  padding: 4px 10px;
  border-radius: 5px;
  border: none;
  background: #fff;
  cursor: pointer;
  outline: none;
}
a {
  color: #000;
}

.full {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.main {
  @extend .full;
  background: #eee;
  overflow: auto;
  display: flex;
  flex-direction: column;
  > p {
    margin-left: 20px;
  }
  > :last-child {
    position: relative;
    flex-grow: 1;
  }
}

@mixin modal-menu () {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0,0,0,.4);
}

#app {
  @extend .full;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  > .main-menu {
    z-index: 400;
    order: 1;
    &.force-modal { @include modal-menu(); }
    > div {
      position: relative;
      width: 230px;
      height: 100%;
      overflow-y: auto;
      box-shadow: 3px 0px 5px rgba(0,0,0,.5);
      background: #fff;

      .inbox {
        display: flex;
        justify-content: space-between;
        :nth-child(2) {
          display: block;
          width: 50px;
          text-align: center;
          border-radius: 10px;
          background: #fdd;
          margin: -5px 0;
          padding: 5px 0;
        }
      }

      h1 {
        margin: 0 0 10px 0;
        padding: 30px 10px 20px 0;
        border-bottom: 3px double #000;
        font-size: 24px;
        img {
          height: 36px;
          vertical-align: bottom;
          padding: 0 3px 0 15px;
        }
      }

      > div {
        a {
          display: block;
          text-decoration: none;
          font-size: 22px;
          padding: 10px 15px;
        }

        > span {
          display: block;
          font-size: 22px;
          padding: 10px 15px;
          color: #ccc;
        }
      }
    }
  }
  > .content {
    order: 2;
    flex-grow: 1;
    position: relative;
  }
}

@media (max-width: 1000px) {
  #app {
    .menu-icon { margin: 0 5px; font-size: inherit; }
    > .main-menu {
      @include modal-menu();
      display: none;
      &.visible {
        display: block;
      }
    }
  }
}

.status { font-size: 18px !important; font-style: italic; }
.okay { color: #080; }
.warn { color: #a80; }
.error:not(input) {
  color: #c00;
  font-weight: bold;
}
input.error, .error input {
  background-color: #fdd;
}

.hoverInfo {
  pointer-events: none;
  z-index: 200;
  display: block;
  position: absolute;
  background-color: rgba(255,255,255,.9);
  padding: 10px;
  border-radius: 10px;
  border: 2px solid #000;
  table {
    border-collapse: collapse;
    th { padding-right: 6px; text-align: left; }
  }
}

.padded {
  padding: 20px;
}
.flex {
  display: flex;
  flex-direction: column;
}
.fill {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.scroll {
  overflow: auto;
}
.flex-toolbar {
  flex-grow: 0;
  padding: 5px 5px 0 10px;
  background: #aaa;
  select {
    margin: 0 10px 5px 0;
  }
  a {
    background: #ccc;
    padding: 5px 10px;
    margin: 0 5px 5px 0;
    border-radius: 5px;
    display: inline-block;
    text-decoration: none;
    &:hover {
      background: #ddd;
    }
    &.active, &.router-link-active {
      background: #fff;
    }
  }
}
.flex-fill {
  flex-grow: 1;
  position: relative;
}

</style>
